import { z } from 'zod';

// Runtime env for the web app.
//
// Defaults are production URLs so the site still loads on Cloudflare Pages
// even if VITE_* variables aren't configured in the dashboard yet. Override
// per-environment (local dev, preview, production) either via a .env file
// or via Pages → Settings → Variables & Secrets.
const schema = z.object({
  VITE_API_URL: z.string().url().default('https://api.prodbattle.com'),
  VITE_WS_URL: z.string().url().default('wss://api.prodbattle.com'),
});

export const env = schema.parse(import.meta.env);
